import {
  Component,
  ElementRef,
  ViewEncapsulation,
  Renderer
} from '@angular/core';

import { BaseDynamicComponent, DialogRef } from 'angular2-modal';

import { MessageModalPreset } from './presets/message-modal-preset';
export class BSModalContainer extends BaseDynamicComponent {
/**
 * @param {?} dialog
 * @param {?} el
 * @param {?} renderer
 */
constructor(public dialog: DialogRef<MessageModalPreset>,
              el: ElementRef, renderer: Renderer) {
    super(el, renderer);
    this.activateAnimationListener();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'bs-modal-container',
  host: {
    'tabindex': '-1',
    'role': 'dialog',
    'class': 'modal fade',
    'style': 'position: absolute; display: block'
  },
  encapsulation: ViewEncapsulation.None,
  template:
`<div [ngClass]="dialog.context.dialogClass" 
      [class.modal-lg]="dialog.context.size == \'lg\'"
      [class.modal-sm]="dialog.context.size == \'sm\'">
  <div class="modal-content" style="display:block" role="document" overlayDialogBoundary>
    <ng-content></ng-content>
  </div>    
</div>`
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: DialogRef, },
{type: ElementRef, },
{type: Renderer, },
];
}

function BSModalContainer_tsickle_Closure_declarations() {
/** @type {?} */
BSModalContainer.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BSModalContainer.ctorParameters;
/** @type {?} */
BSModalContainer.prototype.dialog;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
